export default "__VITE_ASSET__Dwbt4Dgw__"